import { Service } from '@tino-frontend/adapters'

export type RequestOptInArgs = {
  merchantId: string
  supplierId: string
  contact: string
}

export type ConfirmOptInArgs = {
  merchantId: string
  supplierId: string
  has_acknowledge: boolean
}

export class TermsService {
  constructor(private readonly supplierBff: Service) {}

  requestOptIn({ merchantId, supplierId, contact }: RequestOptInArgs) {
    return this.supplierBff.post(`/v1/terms/send`, {
      contact,
      supplier_id: supplierId,
      merchant_id: merchantId,
    })
  }

  confirmOptIn({ merchantId, supplierId, has_acknowledge }: ConfirmOptInArgs) {
    return this.supplierBff.post(`/v1/terms/sign`, {
      accept: has_acknowledge,
      supplier_id: supplierId,
      merchant_id: merchantId,
    })
  }
}
